<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">

            <header>
                <h2 i18n>Warum wir unsere Partner präsentieren</h2>
            </header>

            <p i18n>Wir glauben fest daran, dass unsere Partnerschaften ein Schlüssel zum Erfolg sind. Daher nehmen wir uns die Zeit, unsere geschätzten Partner auf unserer Webseite
                vorzustellen. Warum ist das so wichtig?</p>

            <p class="mb-2"><b i18n>Transparenz und Vertrauen</b></p>
            <p i18n>Die Präsentation unserer Partner ist ein Zeichen von Transparenz. Es zeigt unseren Kunden, dass wir stolz auf die Verbindungen sind, die wir geschaffen haben, und
                dass
                wir voll und ganz hinter den Beziehungen stehen. Dies fördert Vertrauen und Glaubwürdigkeit.</p>

            <p class="mb-2"><b i18n>Gemeinsame Werte und Ziele</b></p>
            <p i18n>Unsere Partner teilen oft ähnliche Werte und Ziele. Indem wir sie auf unserer Webseite präsentiere, zeigen wir, dass wir uns mit mit Organisationen und Unternehmen
                verbinden, die unsere Mission und Vision teilen. Dies stärkt unsere Position in der Branche und unterstreicht unsere gemeinsamen Bemühungen.</p>

            <p class="mb-2"><b i18n>Kooperation und Zusammenarbeit</b></p>
            <p i18n>Die Präsentation unserer Partner ermutigt zur Zusammenarbeit. Kunden, die unsere Partner auf unserer Webseite sehen, erkennen die Möglichkeiten zur Zusammenarbeit
                und
                zur Schaffung von Synergien. Dies führt oft zu fruchtbaren Kooperationen, die den Mehrwert für unsere Kunden steigern.</p>

        </div>
    </section>
</div>
<div class="wrapper">
    <section class="container">

        <div class="row features justify-content-center">
            <section class="col-6 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>IT Cowboys</h2>
                    <small i18n>Mein Experte für Netzwerkbetreuung, Telekommunikation,<br>Webdesign, Datensicherung und Cloud-Computing</small>
                    <p class="pb-0 mb-1" i18n>M.Sc. Michael Haug</p>
                </header>
                <div class="image-wrapper first">
                    <a href="https://www.it-cowboys.de/" target="_blank" rel="noopener noreferrer" class="image featured" aria-label="IT Cowboys Webseite in neuem Tab öffnen" i18n-aria-label><img
                            src="/logos/itCowBoys.webp" alt="IT Cowboys" i18n-alt /></a>
                </div>
                <p i18n>Wir freuen uns sehr Ihnen unseren geschätzten Geschäftspartner, Michael Haug aus Mössingen, vorstellen zu dürfen. Mit beeindruckender Erfahrung und Expertise in
                    den Bereichen Netzwerkbetreuung, Telekommunikation, Webdesign, Datensicherung und Cloud-Computing ist Michael ein unverzichtbarer Bestandteil für uns und unsere
                    Unternehmung.</p>

                <p i18n>Michael Haug ist nicht nur ein Experte in der Technologie, sondern auch ein Teamplayer, der stets bestrebt ist, maßgeschneiderte Lösungen zu finden, die genau
                    zu den Bedürfnissen und Zielen unserer Kunden passen.</p>
                <ul class="actions text-center">
                    <li><a class="glow-on-hover ps-4 pe-4 pt-3 pb-3" href="https://www.it-cowboys.de/" target="_blank" rel="noopener noreferrer" i18n>Zu den IT Cowboys</a></li>
                </ul>
            </section>
            <section class="col-6 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>mhg protectit</h2>
                    <small i18n>Meine Datenschutzexpertin<br><br></small>
                    <p class="pb-0 mb-1" i18n>B.Eng. Larissa Haug</p>
                </header>
                <div class="image-wrapper first">
                    <a href="https://www.mhg-protectit.de/" target="_blank" rel="noopener noreferrer" class="image featured"
                        aria-label="mhg protectit Webseite in neuem Tab öffnen" i18n-aria-label><img src="/logos/mhg protectit.webp" alt="mhg protectit" i18n-alt /></a>
                </div>
                <p i18n>Es ist uns eine Freude Ihnen unsere geschätzte Geschäftspartnerin Larissa Haug vorstellen zu dürfen. Larissa ist unsere Expertin im Bereich Datenschutz und
                    bietet umfangreiche Dienstleistungen zur Entlastung Ihres Unternehmens in Bezug auf Datenschutzfragen.</p>

                <p i18n>Mit ihrem tiefen Verständnis für Datenschutzrichtlinien und -bestimmungen übernimmt Larissa die Verantwortung für die Umsetzung der erforderlichen Maßnahmen in
                    Ihrem Unternehmen. Dies umfasst die Entwicklung datenschutzkonformer Prozesse, Datenschutzprüfungen und die Gewährleistung, dass Ihr Unternehmen stets den
                    höchsten Datenschutzstandards gerecht wird.</p>
                <ul class="actions text-center">
                    <li><a class="glow-on-hover ps-4 pe-4 pt-3 pb-3" href="https://www.mhg-protectit.de/" target="_blank" rel="noopener noreferrer" i18n>Zu mhg protectit</a></li>
                </ul>
            </section>
        </div>
        <div class="row features justify-content-center mt-3">
            <section class="col-6 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>CodeLab</h2>
                    <small i18n>Meine Expertin für Web-Programmierung,<br>Grafikdesign und Android-Programmierung</small>
                    <p class="pb-0 mb-1" i18n>M.Sc. Ana Peterfaj</p>
                </header>
                <div class="image-wrapper first">
                    <a href="https://www.codelab-software.hr/" target="_blank" rel="noopener noreferrer" class="image featured"
                        aria-label="CodeLab Webseite in neuem Tab öffnen" i18n-aria-label><img src="/logos/CodeLab.jpeg" alt="CodeLab" i18n-alt /></a>
                </div>
                <p i18n>Wir sind stolz darauf, Ihnen unsere geschätzte Geschäftspartnerin aus Kroatien vorzustellen – Ana Peterfaj. Ana ist eine herausragende Fachkraft im Bereich der
                    Softwareentwicklung und verfügt über ein beeindruckendes Fachwissen im Angular- und Spring-Framework.</p>

                <p i18n>Mit jahrelanger Erfahrung in der Webentwicklung hat Ana zahlreiche Projekte erfolgreich umgesetzt und dabei innovative Lösungen geschaffen. Ihr junges und
                    innovatives Unternehmen ist immer bereit für neue Herausforderungen.</p>
                <ul class="actions text-center">
                    <li><a class="glow-on-hover ps-4 pe-4 pt-3 pb-3" href="https://www.codelab-software.hr/" target="_blank" rel="noopener noreferrer" i18n>Zu CodeLab</a></li>
                </ul>
            </section>
            <section class="col-6 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>Code Flyers</h2>
                    <small i18n>Mein Expert für Softwareentwicklung,<br>Frontend, Backend und Mobile Development</small>
                    <p class="pb-0 mb-1" i18n>Radek Lejza</p>
                </header>
                <div class="image-wrapper first">
                    <a href="https://codeflyers.com/" target="_blank" rel="noopener noreferrer" class="image featured" aria-label="Code Flyers Webseite in neuem Tab öffnen" i18n-aria-label><img
                            src="/logos/codeflyers.jpg" alt="Code Flyers" i18n-alt /></a>
                </div>
                <p i18n>Code Flyers ist ein enger Partner von AlbCode. Wir unterstützen uns gegenseitig bei der Umsetzung von Projekten in den Bereichen Softwareentwicklung, Frontend,
                    Backend und Mobile Development. Unter der Leitung von Radek Lejza bringt Code Flyers umfassende Expertise und Flexibilität in unsere Zusammenarbeit ein.
                    Gemeinsam stellen wir sicher, dass Projekte erfolgreich und effizient durchgeführt werden, wobei wir stets den Fokus auf Qualität und termingerechte
                    Fertigstellung legen. Diese Partnerschaft stärkt beide Unternehmen und ermöglicht es uns, Kunden optimal zu betreuen.</p>
                <ul class="actions text-center">
                    <li><a class="glow-on-hover ps-4 pe-4 pt-3 pb-3" href="https://codeflyers.com/" target="_blank" rel="noopener noreferrer" i18n>Zu Code Flyers</a></li>
                </ul>
            </section>
        </div>
        <div class="row features justify-content-center mt-3">
            <section class="col-6 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>Zyntak GmbH</h2>
                    <small i18n>Ihr Partner für Datenschutz und Informationssicherheit</small>
                    <p class="pb-0 mb-1"></p>
                </header>
                <div class="image-wrapper first">
                    <a href="https://www.linkedin.com/company/zyntak-gmbh" target="_blank" rel="noopener noreferrer" class="image featured"
                        aria-label="Zyntak GmbH auf LinkedIn in neuem Tab öffnen" i18n-aria-label><img src="/logos/zyntak.jpeg" alt="Zyntak GmbH" i18n-alt /></a>
                </div>
                <p i18n>Die Zyntak GmbH unterstützt Unternehmen mit ihrem integrierten Management System (IMS) dabei, Datenschutz und Informationssicherheit effizient zu vereinen. Durch
                    praxisnahe Lösungen und innovative Technologien sorgt Zyntak dafür, dass Unternehmen die komplexen Anforderungen an Compliance und Sicherheitsstandards
                    erfolgreich umsetzen können.</p>

                <p i18n>Unsere Partnerschaft mit Zyntak basiert auf einem gemeinsamen Verständnis für hohe Sicherheitsstandards und nachhaltige IT-Strategien. Durch die Kombination
                    unserer Softwareentwicklungskompetenz mit Zyntaks IMS-Expertise können wir unseren Kunden ganzheitliche Lösungen anbieten, die nicht nur technisch ausgereift,
                    sondern auch regulatorisch konform sind.</p>

                <p i18n>Mit dieser Kooperation erweitern wir unser Leistungsportfolio gezielt um strategische Beratung und technische Umsetzung im Bereich Datenschutz und
                    Informationssicherheit – für eine sichere und zukunftsorientierte digitale Transformation.</p>
                <ul class="actions text-center">
                    <li><a class="glow-on-hover ps-4 pe-4 pt-3 pb-3" href="https://www.linkedin.com/company/zyntak-gmbh" target="_blank" rel="noopener noreferrer" i18n>Zu Zyntak
                            GmbH</a></li>
                </ul>
            </section>
            <section class="col-6 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>MyCubeServer</h2>
                    <small i18n>Unser Partner für sichere und effiziente IT-Lösungen</small>
                    <p class="pb-0 mb-1"></p>
                </header>
                <div class="image-wrapper first">
                    <a href="https://mycubeserver.com/" target="_blank" rel="noopener noreferrer" class="image featured" aria-label="MyCubeServer Webseite in neuem Tab öffnen" i18n-aria-label><img
                            src="/logos/MyCubeServer.png" alt="MyCubeServer" i18n-alt /></a>
                </div>
                <p i18n>AlbCode und MyCubeServer verbindet eine gemeinsame Mission: Unternehmen mit innovativen IT- und Cloud-Lösungen effizienter und sicherer zu machen. Durch
                    unsere
                    Partnerschaft ermöglichen wir Kunden, digitale Prozesse nahtlos zu optimieren und moderne, sichere Remote-Arbeitsplätze zu schaffen.</p>
                <p i18n>Mit MyCubeServers innovativer Nexus-Technologie sorgen wir gemeinsam für maximalen Schutz vor Cyberangriffen und eine leistungsstarke IT-Infrastruktur. Ihr
                    flexibles Cloud-Angebot und ihre 360° Managed IT Services ergänzen unser individuelles Softwareentwicklungs-Know-how perfekt. So bieten wir
                    maßgeschneiderte,
                    sichere und zukunftsorientierte Lösungen aus einer Hand.</p>
                <p i18n>Unsere Zusammenarbeit basiert auf Vertrauen, Transparenz und dem gemeinsamen Ziel, unseren Kunden die besten digitalen Möglichkeiten zu bieten. Mit AlbCode &
                    MyCubeServer sind Sie bereit für die digitale Zukunft!</p>
                <ul class="actions text-center">
                    <li><a class="glow-on-hover ps-4 pe-4 pt-3 pb-3" href="https://mycubeserver.com/" target="_blank" rel="noopener noreferrer" i18n>Zu MyCubeServer</a></li>
                </ul>
            </section>
        </div>
        <div class="row features justify-content-center mt-3">
            <section class="col-6 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>2B+ Mentoring</h2>
                    <small i18n>Meine Experte für BCM,<br>Unternehmensführung und Geschäftsentwicklung</small>
                    <p class="pb-0 mb-1" i18n>Manfred Biffar</p>
                </header>
                <div class="image-wrapper first">
                    <a href="https://www.2bplusmentoring.de/" target="_blank" rel="noopener noreferrer" class="image featured"
                        aria-label="2B+ Mentoring Webseite in neuem Tab öffnen" i18n-aria-label><img src="/logos/2bplusmentoring.png" alt="2B+ Mentoring" i18n-alt /></a>
                </div>
                <p i18n>2B+ Mentoring begleitet Unternehmen mit einem umfassenden Leistungsportfolio im Bereich Business Continuity Management, Risikomanagement und Nachhaltigkeit. Als
                    zertifizierter Anbieter nach DIN EN ISO 22301:2019 unterstützt 2B+ Unternehmen dabei, Geschäftsprozesse sicher und nachhaltig zu gestalten. Neben der Einführung
                    von Standards bietet 2B+ durch individuelles Mentoring eine kontinuierliche Begleitung an, um Unternehmen bestmöglich auf unerwartete Herausforderungen
                    vorzubereiten und langfristige Stabilität zu gewährleisten.</p>
                <ul class="actions text-center">
                    <li><a class="glow-on-hover ps-4 pe-4 pt-3 pb-3" href="https://www.2bplusmentoring.de/" target="_blank" rel="noopener noreferrer" i18n>Zu 2B+ Mentoring</a></li>
                </ul>
            </section>
            <section class="col-6 col-12-narrower feature">

            </section>
        </div>
    </section>
</div>